import { useTranslation } from "react-i18next";
import type { ManualMediaRef } from "@arc/contracts";

/** The viewer's media renderer (image / video / audio / other) — its own module so both the step view and the
 *  interactive player (which the step view imports) can use it without a dependency cycle (ADR-027 §11 B). */
export function StepMedia({ media, name }: { media: ManualMediaRef; name: string }) {
  const { t } = useTranslation();
  if (media.kind === "video") {
    return <video src={media.url ?? undefined} controls className="border-border max-h-[55vh] w-full rounded-md border bg-black" />;
  }
  if (media.kind === "image") {
    return <img src={media.url ?? undefined} alt={media.name ?? name} className="border-border max-h-[55vh] w-full rounded-md border object-contain" />;
  }
  if (media.kind === "audio") {
    return <audio src={media.url ?? undefined} controls className="w-full" />;
  }
  return (
    <p className="text-muted-foreground border-border rounded-md border border-dashed p-3 text-sm">
      {t("viewer.attachment", { name: media.name ?? t("viewer.fileFallback"), kind: media.kind })}
    </p>
  );
}
